import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./home.css";
import scryerLogo from "./scryer-logo-x500.png"; // Adjust path if needed

const Home: React.FC = () => {
  const [animate, setAnimate] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user already logged in (token stored)
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard"); // redirect to dashboard if logged in
    } else {
      setAnimate(true);
    }
  }, [navigate]);

  return (
    <div className="home-hero">
      <div className={`home-overlay ${animate ? "fade-in" : ""}`} />
      <div className={`home-content ${animate ? "slide-up" : ""}`}>
        <img
          src={scryerLogo}
          alt="Scryer Logo"
          className="home-logo inverted-logo"
          onLoad={() => setLogoLoaded(true)}
          onError={() => setLogoLoaded(false)}
          style={{ display: logoLoaded ? "block" : "none" }}
        />
        {!logoLoaded && <h1 className="home-title">Scryer Cyber Insurance</h1>}
        <p className="home-subtitle">
          Confident coverage, powered by your actual security controls.
        </p>
        <div className="home-buttons">
          <Link to="/login" className="btn btn-secondary">
            Login
          </Link>
          <Link to="/signup" className="btn btn-primary">
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
